import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DeactivateGuard } from '../../shared/guards/candeactivate';
import { OpcodeServiceManagementComponent } from './opcode-service-management.component';


const routes: Routes = [
  {
    path:'',
    component: OpcodeServiceManagementComponent,
    canDeactivate:[DeactivateGuard]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OpcodeServiceManagementRoutingModule { }
